import moment from 'moment'
import React, { useState } from 'react'
import { Dropdown, Menu } from 'antd'
import Select from 'react-select'

import { AiOutlineDown, AiOutlineReload } from 'react-icons/ai'

import Receive from '../../components/reusable/receive'
import SystemLog from '../../components/modals/systemLog'

import { stringifyDate, useListData, usePet, useSocketEvents, useToggle, ws } from '../../modules'
import DateRangePicker from '../../components/reusable/rangePicker'
import Confirm from '../../components/reusable/confirm'

const Logs = () => {
    const [selected, setSelected] = useState()
    const [string, setString] = useState('')
    const [category, setCategory] = useState()
    const [categories, setCategories] = useState([])
    const [ranges, setRanges] = useState([moment().startOf('day'), moment().endOf('day')])

    const [logModal, toggleLogModal] = useToggle()
    
    const [
        { loading, error, fetch }, 
        { list: logs }, 
        { navigate, Paginate, page = 1, limit = 10 }
    ] = useListData('logs', ranges ? { 
        string, 
        category: category?.value,
        from: ranges[0]?._d ?? null, 
        to: ranges[1]?._d ?? null
     } : { string, category: category?.value }, { notify: true, manual: false }, 'logs', 20)

    const [, fetchCategories] = usePet('logCategories', { id: selected?._id }, { notify: true, callback: ({ data }) => setCategories(data.map(x => ({ value: x, label: x }))) })

    const [, stopCodeBlue] = usePet('stopCodeBlue', null, { notify: true, callback: () => null, manual: true, load: { msg: 'Stopping Alert...' } })

    const refresh = () => {
        navigate(1)
        fetch()
        fetchCategories()
    }

    const search = str => {
        setString(str)
        refresh()
    }

    const changeCategory = val => {
        setCategory(val)
        refresh()
    }

    const selectRange = range => {
        setRanges(range)
        refresh()
    }

    const showLog = log => {
        setSelected(log)
        toggleLogModal()
    }

    const stopCodeBlueAlert = () => Confirm({
        title: 'Stop Code Blue Alert',
        message: 'Are you sure you want to stop the Code Blue Alert?',
        callback: stopCodeBlue
    })

    useSocketEvents({
        'new-error-log': {
            condition: data => true,
            notif: {
                message: 'New Error Log',
                type: 'warning'
            },
            callback: () => refresh()
        }
    })
    
    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full mx-auto">
            {
                logModal &&
                <SystemLog 
                    log={ selected }
                    visible={ logModal }
                    toggle={ toggleLogModal } />
            }
            <div className="sm:flex sm:justify-between sm:items-center mb-8">
                <input
                    onChange={e => search(e.target.value)}
                    className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                    id="grid-search"
                    type="text"
                    placeholder="Search by Name" />
                <DateRangePicker selectRange={selectRange} ranges={ ranges } />
            </div>
            <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                <header className="px-5 py-4 border-b border-gray-100 flex justify-between items-center">
                    <h2 className="font-semibold text-gray-800">System Logs</h2>
                    <span className="flex items-center justify-between">
                        <Select
                            isClearable
                            value={ category }
                            onChange={ changeCategory }
                            styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                            options={ categories }
                            placeholder="Select category" />
                        <button onClick={refresh} className="btn ml-2 py-3 hisani-btn-green-light text-white">
                            <AiOutlineReload style={{ color: "white" }} />
                        </button>
                    </span>
                </header>
                <div className="p-3">

                    {/* Table */}
                    <div className="overflow-x-auto">
                        <Receive
                            error={error}
                            loading={loading}
                            progress>
                            {
                                logs.length > 0 ?
                                    <table className="table-auto w-full">
                                        {/* Table header */}
                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                            <tr>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">No</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Desc</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Category</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Updated By</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Updated On</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center"></div>
                                                </th>
                                            </tr>
                                        </thead>
                                        {/* Table body */}
                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                            {/* Row */}
                                            {
                                                logs.map((log, key) =>
                                                    <tr>
                                                        <td className="p-2">
                                                            <div className="text-center">{((page - 1) * limit) + key + 1}.</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="">{ log.title }</div>
                                                            <p className="text-gray-500 mb-0 text-xs italic">{ log.desc }</p>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className={ log.category.toLowerCase().includes('error') ? 'text-red-500' : 'text-gray-500' }>{ log.category }</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-center">{ stringifyDate(log.date) }</div>
                                                        </td>
                                                        <td className="p-2 text-center">
                                                            <Dropdown
                                                                overlay={
                                                                    <>
                                                                        <Menu>
                                                                            <Menu.Item onClick={ () => showLog(log) }>View</Menu.Item>
                                                                        </Menu>
                                                                        {
                                                                            log.category.toLowerCase().includes('code-blue') &&
                                                                            <Menu>
                                                                                <Menu.Item onClick={ stopCodeBlueAlert }>Stop Code Blue</Menu.Item>
                                                                            </Menu>
                                                                        }
                                                                    </>
                                                                }>
                                                                <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                            </Dropdown>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                :
                                    <div className="w-full h-16 flex items-center justify-center">
                                        <p className="font-semibold text-base">No logs have been recorded so far</p>
                                    </div>
                            }
                        </Receive>
                        {Paginate}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Logs